import { render, staticRenderFns } from "./SelectPharmacy.vue?vue&type=template&id=74227bc9&"
import script from "./SelectPharmacy.vue?vue&type=script&lang=ts&"
export * from "./SelectPharmacy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports